import { controls, currencyToNumber, grouped } from "../../controls";

const department_bill_of_month = {
  label: "Department Bill",
  starting: true,
  url: "department_bill_of_month",
  pageLabel: "Department Bill",
  pageType: "history",
  visitingBranches: true,
  filter: [
      ...controls.displayText({ tab: "general", label: "Department", star: false }),
        ...controls.oc({ tab: "general", c: "Department", placeHolder: "Department Code", name: "department_code", fastpath: "departments", isReadOnly: "edit", hidden: false}),
        ...controls.showData({ tab: "general", displaytype: "capital", data: "department_display" }),
  
      ...controls.magicDateLabel({ label: "Date", target: "Salary Month" }),
    ...controls.magicDate({ dateType: "ontype", default: "n", isRequired: true, name: "salary_month", width: "col-sm-2", displayFormat: "MMMM yyyy" }),
    ...controls.magicDateLabel({ label: "", width: "col-sm-2" }),
  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Department Bill",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },

    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "Department",
        accessor: "department_display",
        rwidth: "*"
      },
      {
        Header: "BASIC",
        accessor: "basic"
      },
      {
        Header: "LP",
        accessor: "lp"
      },
      {
        Header: "GP",
        accessor: "gp"
      },
       {
        Header: "CA",
        accessor: "ca"
      },
      {
        Header: "WA",
        accessor: "wa"
      },
       {
        Header: "OT",
        accessor: "ot"
      },
      {
        Header: "DA",
        accessor: "da"
      },
       {
        Header: "HRA",
        accessor: "hra"
      },
     {
        Header: "TOTAL",
        accessor: "total"
      },
       {
        Header: "PT",
        accessor: "pt"
      },
       {
        Header: "GPF",
        accessor: "gpf"
      },
       {
        Header: "GIS",
        accessor: "gis"
      },
      {
        Header: "LIC",
        accessor: "lic"
      },
       {
        Header: "IT",
        accessor: "it"
      },
       {
        Header: "Fest Advance",
        accessor: "fest_advance"
      },
      {
        Header: "Mc Loan",
        accessor: "mc_loan"
      },
       {
        Header: "Bank Loan",
        accessor: "bank_loan"
      },
       {
        Header: "Other Deductions",
        accessor: "other_deductions"
      },
        {
        Header: "Total Deductions",
        accessor: "total_deductions"
      },
          {
        Header: "Payable",
        accessor: "Payable"
      },

      
    ]
  }
};

export default department_bill_of_month;